import React, { useContext } from 'react';

const LightwaveContext = React.createContext({});
export const LightwaveContextProvider = LightwaveContext.Provider;

export function useLightwaveContext() {
  return useContext(LightwaveContext);
}
